import type { GetStaticPaths, GetStaticProps } from 'next';

import { makeStaticPathsRequest, makeStaticPropsRequest } from '../modules/page-marketing/get-static-props';
import { makeMarketingPage } from '../modules/page-marketing/page-marketing';
import type { MarketingPageProps, UrlParams } from '../modules/page-marketing/types';

const MarketingPage = makeMarketingPage();
export default MarketingPage;

export const getStaticProps: GetStaticProps<MarketingPageProps, UrlParams> = ({ params, preview }) =>
  makeStaticPropsRequest(params.slug, 'No marketing page entry found', preview);

export const getStaticPaths: GetStaticPaths<UrlParams> = () => makeStaticPathsRequest();
